module.exports = __webpack_public_path__ + "static/media/3DPPA23.1a6e0610.jpg";